module.exports = __webpack_public_path__ + "img/default-hot.a1c14042.png";